<div class="preflight-modal">
	<div class="preflight-modal__header">
		<h2 class="fw-bold fs-xs">Revisar organização não identificada</h2>
		<button mat-icon-button type="button" (click)="onCancel()">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<p class="fs-xxs gray">
		{{ introText }}
	</p>

	<div class="preflight-modal__summary">
		<div class="preflight-modal__summary-grid">
			<div class="preflight-info-card preflight-info-card--wide">
				<span>{{ identifierTitle }}</span>
				<strong>{{ identifierLabel }}</strong>
			</div>
			<div class="preflight-info-card">
				<span>Linhas afetadas</span>
				<strong>{{ data.group.rowCount }}</strong>
			</div>
		</div>
		<div class="preflight-reasons">
			<span class="preflight-reasons__label">Motivo</span>
			<div class="preflight-reasons__chips">
				<span
					class="preflight-reason-chip"
					*ngFor="let label of issueLabelList"
				>
					{{ label }}
				</span>
			</div>
		</div>
	</div>

	<div class="preflight-modal__actions">
		<button
			*ngIf="data.pendingChange"
			mat-button
			color="primary"
			type="button"
			(click)="onRemove()"
		>
			Remover da fila
		</button>
		<button
			*ngIf="canResume"
			mat-stroked-button
			color="primary"
			type="button"
			(click)="onResume()"
		>
			Retomar
		</button>
		<button
			mat-stroked-button
			color="primary"
			type="button"
			(click)="onIgnore()"
		>
			Ignorar
		</button>
		<button
			*ngIf="canTreatAsMatrix"
			mat-stroked-button
			color="primary"
			type="button"
			(click)="onTreatAsMatrix()"
		>
			Tratar como matriz
		</button>
		<button
			*ngIf="canCreateSub"
			mat-flat-button
			color="primary"
			type="button"
			(click)="onCreateSub()"
		>
			Criar nova sub
		</button>
	</div>
</div>
